<template>
<div>
  <h3>Demographic Information</h3>
  <div class="m-4 formDiv">
    <b-form v-if="show">
      <b-form-group>
        <b-row class="text-left">
          <b-col sm="1">
            <label for="input-age">Age:</label>
          </b-col>
          <b-col sm="4">
            <b-form-input
              id="input-age"
              type="number"
              v-model="form.age"
              required
              placeholder="Enter Age"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <br>

    <b-form-group label="Sex/Gender:">
      <b-form-radio v-model="form.sex" name="sex" value="1">Male</b-form-radio>
      <b-form-radio v-model="form.sex" name="sex" value="2">Female</b-form-radio>
      <b-form-radio v-model="form.sex" name="sex" value="3">Non-Binary or other</b-form-radio>
      <b-form-radio v-model="form.sex" name="sex" value="4">Prefer not to report.</b-form-radio>
    </b-form-group>

      <br>
      <b-form-group label="Ethnicity:">
      <b-form-radio v-model="form.ethnicity" name="ethnicity" value="1">
          Hispanic or Latino
          </b-form-radio>
      <b-form-radio v-model="form.ethnicity" name="ethnicity" value="2">
          Not Hispanic or Latino
          </b-form-radio>
      <b-form-radio v-model="form.ethnicity" name="ethnicity" value="3">
          Prefer not to report.
          </b-form-radio>
    </b-form-group>
      <br>
    <b-form-group label="Race:">
      <b-form-checkbox-group id="checkbox-race" v-model="form.race" name="race">
      <b-form-checkbox value="1">
          American Indian/Alaska Native
          </b-form-checkbox><br>
      <b-form-checkbox value="2">
          Asian
          </b-form-checkbox><br>
      <b-form-checkbox value="3">
          Native Hawaiian or Other Pacific Islander
          </b-form-checkbox><br>
      <b-form-checkbox value="4">
          Black or African American
          </b-form-checkbox><br>
      <b-form-checkbox value="5">
          White
          </b-form-checkbox><br>
      <b-form-checkbox value="7">
          Prefer Not to Report
          </b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>
        <br>
</b-form>
  </div>
<alert :message="message" v-if="showMessage"></alert>
<b-button @click="checkForm" class="rounded-pill" variant="info">Submit</b-button>

</div>
</template>

<style>
.formDiv{
    text-align: left;
}

</style>

<script>
import axios from 'axios';
import Alert from '../Other/Alert.vue';

export default {
  name: 'Demographic',
  data() {
    return {
      userID: null,
      form: {
        age: null,
        sex: null,
        race: [],
        ethnicity: null,
      },
      show: true,
      showMessage: false,
      message: '',
    };
  },
  components: {
    alert: Alert,
  },
  methods: {
    submitForm(payload) {
      const path = `${this.$hostname}/submit-demographic/${this.userID}`;
      // const path = `http://localhost:8080/submit-demographic/${this.userID}`;
      axios
        .put(path, payload)
        .then((res) => {
          if (!res.data.isLoggedIn) {
            alert('Please Login!');
            this.$router.push({ name: 'Login' });
          } else {
            localStorage.accountProgress = 'Task';
            localStorage.taskProgress = 'IMC';
            this.$router.push({ name: 'IMC' });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.message = 'Server Error';
          this.showMessage = true;
        });
    },
    initForm() {
      this.form.first_name = '';
      this.form.last_name = '';
      this.form.email = '';
      this.form.phone_number = '';
    },
    checkForm() {
      const checkform = [this.form.age,
        this.form.sex,
        this.form.ethnicity];
      const checkrace = this.form.race;
      console.log(checkrace.length);
      if (!checkform.includes(null) && checkrace.length) {
        this.submitForm(this.form);
      } else {
        this.message = 'Please fill out the survey form';
        this.showMessage = true;
      }
    },
  },
  created() {
    this.userID = localStorage.userID;
    if (localStorage.accountProgress !== 'Demographic') {
      this.$router.push({ name: 'Task' });
    }
  },
};
</script>
